<template>
<div class="tab-wrapper">
  <h3 class="mb16">物业交割清单</h3>
  <div class="content"  v-if="deliverysInfo">
    <div class="item pt16 pb16">
      <h4 class="mb8">生活费用信息</h4>
      <table-list :showPage ="false" :columns="meterColumns" :data="deliverysInfo.meterDeliveryDtos" :loading="costLoading"></table-list>
    </div>

    <div class="item pt16 pb16">
      <h4 class="mb8">房间物品信息</h4>
      <table-list :showPage ="false" :columns="goodsColumns" :data="deliverysInfo.goodsDelivery" :loading="goodsLoading"></table-list>
    </div>

    <div class="item pt16 pb16">
      <h4 class="mb8">房间装修信息</h4>
      <table-list :showPage ="false" :columns="deGoodsColumns" :data="deliverysInfo.deGoodsDelivery" :loading="decorationLoading"></table-list>
    </div>

  </div>
</div>
 
</template>
 
<script type="text/ecmascript-6">
import defaultImg from '@/assets/filedefault.jpg'
import TableList from "components/TableList/index";
export default {
  props:{
    deliverysInfo:{
      type:Object,
      default:null
    }
  },
  components:{
    TableList
  },
 data () {
  return {
    show:false,
    costLoading:false,
    goodsLoading:false,
    decorationLoading:false,
    meterColumns:[
      {
        title: "项目类型",
        key: "typeName",
        align: "center"
      },
      {
        title: "是否智能",
        key: "isCapacity",
        align: "center",
        render:(h,params) => {
          return h('span',params.row.isCapacity? '是':'否')
        }
      },
      {
        title: "付费模式",
        key: "chargeMode",
        align: "center"
      
      },
      {
        title: "上次示数",
        key: "preDisplay",
        align: "center"
      
      },
      {
        title: "本次示数",
        key: "curDisplay",
        align: "center"
      
      },
      {
        title: "单价",
        key: "price",
        align: "center"
      
      },
      {
        title: "应退费用",
        key: "amout",
        align: "center"
      
      },
      {
        title: "附件",
        key: "attachment",
        align: "center",
        render: (h,params) => {
          return h('span',{
            style:{
              color: '#CFA868',
              cursor: params.row.attachment ? 'pointer': 'auto'
            },
            on: {
              click: ()=>{
                if(params.row.attachment ){
                   this.$emit('showimg', params.row.attachment)
                }
              }
            }
          },params.row.attachment ? '查看' : '-')
        }
      },
    ],       
    goodsColumns:[
      {
        title: "类目",
        key: "goodsType",
        align: "center"
      },
      {
        title: "物品",
        key: "goodsName",
        align: "center"
      },
      {
        title: "数量",
        key: "goodsCount",
        align: "center"
      },
      {
        title: "价格",
        key: "goodsPrice",
        align: "center"
      },
      {
        title: "状态",
        key: "goodsStatus",
        align: "center",
        render:(h,params) => {
          let str = ''
          switch(params.row.goodsStatus){
            case 0: 
              str = '正常'
              break;
            case 1: 
              str = '损坏'
              break;
            case 2: 
              str = '报废'
              break;
            case 3: 
              str = '终结'
              break;
            default:
            str = ''
          }
          return h('span',str)
        }
      },
      {
        title: "赔付费用",
        key: "goodsPayAmount",
        align: "center"
      }
    ],
    
    deGoodsColumns:[
      {
        title: "装修项目",
        key: "goodsName",
        align: "center"
      },
      {
        title: "新旧",
        key: "goodsNewOld",
        align: "center",
        render:(h,params) => {
          return h('span',params.row.goodsNewOld==0?'新':'旧')
        }
      },
      {
        title: "面积（㎡）",
        key: "unit",
        align: "center"
      },
      {
        title: "状态",
        key: "goodsStatus",
        align: "center",
        render:(h,params) => {
          let str = ''
          switch(params.row.goodsStatus){
            case 0: 
              str = '正常'
              break;
            case 1: 
              str = '损坏'
              break;
            case 2: 
              str = '报废'
              break;
            case 3: 
              str = '终结'
              break;
            default:
            str = ''
          }
          return h('span',str)
        }
      },
       {
        title: "赔付费用",
        key: "goodsPayAmount",
        align: "center"
      }
    ]
 
 };
 },
 methods:{
close() {
  this.show = false
}
 }
}
</script>




